import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import common from './modules/common';

const store = new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  modules: {
    common,
  }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js